import { render, staticRenderFns } from "./Trainees.vue?vue&type=template&id=6d5b7250&scoped=true&"
import script from "./Trainees.vue?vue&type=script&lang=js&"
export * from "./Trainees.vue?vue&type=script&lang=js&"
import style0 from "./Trainees.vue?vue&type=style&index=0&id=6d5b7250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b7250",
  null
  
)

export default component.exports